import { atom } from "jotai";

export const statusListsAtom = atom([]);
export const partnerStatusListsAtom = atom([]);
